/* Goloka V3 dealer: wholesale form validation + quick order grid. Loads on every page, inits only where present. */
(function () {
  if (window.__v3dealer) return;
  window.__v3dealer = true;

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var PHONE = /^[+\d][\d\s()-]{6,}$/;
  var GSTIN = /^\d{2}[A-Z]{5}\d{4}[A-Z][A-Z\d]Z[A-Z\d]$/i;

  function check(input) {
    var kind = input.getAttribute('data-v3d-validate');
    var v = (input.value || '').trim();
    if (kind === 'required') return v ? '' : 'Enter ' + (input.getAttribute('data-v3d-label') || 'this field') + '.';
    if (kind === 'email') {
      if (!v) return 'Enter your email address.';
      return EMAIL.test(v) ? '' : 'Enter a valid email address, like name@example.com.';
    }
    if (kind === 'phone') {
      if (!v) return 'Enter a phone number we can reach you on.';
      return PHONE.test(v) ? '' : 'Enter a valid phone number.';
    }
    if (kind === 'gstin') return !v || GSTIN.test(v) ? '' : 'GSTIN has 15 characters, like 27ABCDE1234F1Z5. Leave blank if you do not have one.';
    return '';
  }
  function show(input, msg) {
    var err = document.getElementById(input.id + '-err');
    if (!err) return;
    if (msg) {
      err.textContent = msg; err.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', err.id);
    } else {
      err.textContent = ''; err.hidden = true;
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    }
  }
  function initForm() {
    var f = document.getElementById('v3d-form');
    if (!f) return;
    var inputs = Array.prototype.slice.call(f.querySelectorAll('[data-v3d-validate]'));
    inputs.forEach(function (input) {
      input.addEventListener('blur', function () { show(input, check(input)); });
      input.addEventListener('input', function () { if (input.getAttribute('aria-invalid')) show(input, check(input)); });
    });
    f.addEventListener('submit', function (e) {
      var first = null;
      inputs.forEach(function (input) {
        var msg = check(input);
        show(input, msg);
        if (msg && !first) first = input;
      });
      if (first) { e.preventDefault(); first.focus(); }
    });
    var t = f.querySelector('[data-v3d-success], [data-v3d-formerrors]');
    if (t) t.focus();
  }

  /* Quick order */
  function money(paise) {
    var r = Math.round(paise) / 100;
    return '₹' + r.toLocaleString('en-IN', { maximumFractionDigits: 2 });
  }
  function unitPrice(input, qty) {
    var price = +input.dataset.price;
    var br = input.dataset.breaks;
    if (br) {
      br.split(',').forEach(function (pair) {
        if (!pair) return;
        var p = pair.split(':');
        if (qty >= +p[0]) price = +p[1];
      });
    }
    return price;
  }
  function initQuick() {
    var root = document.querySelector('[data-v3d-qo]');
    if (!root) return;
    var qtys = Array.prototype.slice.call(root.querySelectorAll('[data-v3d-qty]'));
    var addBtn = root.querySelector('[data-v3d-add]');
    var countEl = root.querySelector('[data-v3d-count]');
    var totalEl = root.querySelector('[data-v3d-total]');
    var msg = root.querySelector('[data-v3d-msg]');
    var bar = root.querySelector('[data-v3d-bar]');

    function say(text) { msg.textContent = text || ''; msg.hidden = !text; }
    function fix(input) {
      var step = +input.dataset.step || 1, min = +input.dataset.min || 1;
      var max = input.max ? +input.max : Infinity;
      var q = parseInt(input.value, 10);
      if (!q || q < 0) q = 0;
      if (q > 0) {
        if (q < min) q = min;
        if (step > 1) q = Math.ceil((q - min) / step) * step + min;
        if (q > max) q = Math.floor((max - min) / step) * step + min;
      }
      input.value = q;
      return q;
    }
    function update() {
      var lines = 0, units = 0, total = 0;
      qtys.forEach(function (input) {
        var q = parseInt(input.value, 10) || 0;
        var sub = input.closest('tr').querySelector('[data-v3d-sub]');
        if (q > 0) {
          var line = unitPrice(input, q) * q;
          sub.textContent = money(line);
          total += line; units += q; lines++;
          input.closest('tr').classList.add('has-qty');
        } else {
          sub.textContent = '–';
          input.closest('tr').classList.remove('has-qty');
        }
      });
      countEl.textContent = units + (units === 1 ? ' item' : ' items') + (lines > 1 ? ' · ' + lines + ' lines' : '');
      totalEl.textContent = money(total);
      addBtn.disabled = units === 0;
      bar.classList.toggle('is-active', units > 0);
    }
    qtys.forEach(function (input) {
      input.addEventListener('input', function () { say(''); update(); });
      input.addEventListener('change', function () { fix(input); update(); });
      input.addEventListener('focus', function () { input.select(); });
    });

    var filter = root.querySelector('[data-v3d-filter]');
    var empty = root.querySelector('[data-v3d-empty]');
    if (filter) filter.addEventListener('input', function () {
      var q = filter.value.trim().toLowerCase(), shown = 0;
      root.querySelectorAll('[data-v3d-row]').forEach(function (row) {
        var hit = !q || row.dataset.name.indexOf(q) !== -1;
        row.hidden = !hit;
        if (hit) shown++;
      });
      if (empty) empty.hidden = shown !== 0;
    });

    addBtn.addEventListener('click', function () {
      var items = [];
      qtys.forEach(function (input) {
        var q = fix(input);
        if (q > 0) items.push({ id: +input.dataset.id, quantity: q });
      });
      if (!items.length) return;
      addBtn.disabled = true;
      var label = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      fetch(root.dataset.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart.');
          window.location.href = root.dataset.cartUrl;
        })
        .catch(function (err) {
          // Shopify can add part of a request (e.g. stock limits) and still error: refresh the count so the dealer sees what landed.
          say((err.message || 'Could not add to cart.') + ' Check your cart before adding again.');
          fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
            var cc = root.querySelector('[data-v3d-cartcount]'); if (cc) cc.textContent = '(' + c.item_count + ')';
          }).catch(function () {});
          addBtn.textContent = label;
          addBtn.disabled = false;
        });
    });
    update();
  }

  function init() { initForm(); initQuick(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
